import Http from "./Http";

export class PushNotificationsService extends Http {
  /**
   * Get income statistics
   * @param {Object} body
   * @param {string} body.token
   */
  registerDevice(body) {
    return this.post("/user-devices", body);
  }
}

export default new PushNotificationsService();
